var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.999994H1.99999C1.86658 0.991974 1.73298 1.01235 1.60802 1.05976C1.48306 1.10718 1.36958 1.18057 1.27508 1.27508C1.18057 1.36958 1.10718 1.48306 1.05976 1.60802C1.01235 1.73298 0.991974 1.86658 0.999994 1.99999V16C0.991974 16.1334 1.01235 16.267 1.05976 16.392C1.10718 16.5169 1.18057 16.6304 1.27508 16.7249C1.36958 16.8194 1.48306 16.8928 1.60802 16.9402C1.73298 16.9876 1.86658 17.008 1.99999 17H9.99999L15 12V1.99999C15.008 1.86658 14.9876 1.73298 14.9402 1.60802C14.8928 1.48306 14.8194 1.36958 14.7249 1.27508C14.6304 1.18057 14.5169 1.10718 14.392 1.05976C14.267 1.01235 14.1334 0.991974 14 0.999994ZM2.99999 2.99999H13V11H8.99999V15H2.99999V2.99999Z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5H4.99999V6H11V5Z",
    fill: "#8E8E8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8H4.99999V9H11V8Z",
    fill: "#8E8E8E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 11H4.99999V12H6.99999V11Z",
    fill: "#8E8E8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/media/icon_list.a0987761.svg";
export { ForwardRef as ReactComponent };